import React, { useState, useEffect } from 'react'

// Antd
import { Button, Col, Drawer, Form, Input, Row, Select, notification, Spin, message, Radio, Upload, Divider } from 'antd';

import TextArea from 'antd/es/input/TextArea';
import { useSelector } from 'react-redux';
import { addCourse, getAllUsers } from '../../../../Constants/Api/functions/function';
import { UPLOAD_COURSE_THUMBNAIL_URL } from '../../../../Constants/Api/azure/azure';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

const quillModules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ align: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const { Option } = Select;

const AddCource = ({
    isOpen,
    setOpen,
    hadleGetCources
}) => {
    const [api, contextHolder] = notification.useNotification();
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const allCources = useSelector(state => state.allCources.allCources);
    const [fileList, setFileList] = useState([]);
    const [installmentCount, setInstallmentCount] = useState(0);
    const [alumniInstallmentCount, setAlumniInstallmentCount] = useState(0);
    const [instructors, setInstructors] = useState([]);
    const [coordinators, setCoordinators] = useState([]);

    useEffect(() => {
        const fetchInstructors = async () => {
            try {
                const users = await getAllUsers(2); // Center 2
                if (users) {
                    const filtered = users.filter(u => u.role === 'instructor');
                    setInstructors(filtered);
                    setCoordinators(users.filter(u => u.role === 'coordinator'));
                }
            } catch (error) {
                console.error("Failed fetching instructors:", error);
            }
        };
        if (isOpen) {
            fetchInstructors();
        }
    }, [isOpen]);

    const handleInstallmentCountChange = (event) => {
        const value = parseInt(event?.target?.value, 10);
        if (Number.isNaN(value) || value <= 0) {
            setInstallmentCount(0);
            return;
        }
        setInstallmentCount(value);
    };

    const handleAlumniInstallmentCountChange = (event) => {
        const value = parseInt(event?.target?.value, 10);
        if (Number.isNaN(value) || value <= 0) {
            setAlumniInstallmentCount(0);
            return;
        }
        setAlumniInstallmentCount(value);
    };

    const onFinish = async (values) => {
        setIsLoading(true);

        Object.keys(values).forEach(key => (values[key] === undefined || values[key] === '') && delete values[key]);
        values.createdBy = userProfile.id;

        if (values.isPublished === 'true') {
            values.isPublished = true;
        } else {
            values.isPublished = false;
        }

        if (values.isAppearOnHome === true) {
            values.isAppearOnHome = true;
        } else {
            values.isAppearOnHome = false;
        }

        if (values.isPromoActive === true || values.isPromoActive === 'true') {
            values.isPromoActive = true;
        } else {
            values.isPromoActive = false;
        }

        if (values.isShowOnHome === 'true') {
            values.isShowOnHome = true;
        } else {
            values.isShowOnHome = false;
        }

        if (values.tags) {
            values.tags = values.tags.join(',');
        }

        if (fileList.length < 1) {
            openNotification('error',
                'Upload course cover image',
                'Please upload course cover image to continue'
            );
            setIsLoading(false);
            return;
        }

        if (values.installments !== undefined) {
            values.installments = Number(values.installments) || 0;
        }

        if (values.installments > 0) {
            const normalizedInstallments = (values.installmentAmounts || [])
                .slice(0, values.installments)
                .map((amount, index) => ({
                    installmentNumber: index + 1,
                    amount: Number(amount) || 0,
                    dueDate: values.installmentDueDate && values.installmentDueDate[index] ? values.installmentDueDate[index] : null
                }));
            values.installmentAmounts = normalizedInstallments;
        } else {
            values.installmentAmounts = [];
        }

        if (values.alumniInstallmentAmounts && values.installments > 0) {
            const normalizedAlumniInstallments = (values.alumniInstallmentAmounts || [])
                .slice(0, values.installments)
                .map((amount, index) => ({
                    installmentNumber: index + 1,
                    amount: Number(amount) || 0,
                    dueDate: values.installmentDueDate && values.installmentDueDate[index] ? values.installmentDueDate[index] : null
                }))
                .filter(inst => inst.amount > 0);
            values.alumniInstallmentAmounts = normalizedAlumniInstallments;
            values.alumniInstallments = normalizedAlumniInstallments.length;
        } else {
            values.alumniInstallmentAmounts = [];
            values.alumniInstallments = 0;
        }

        if (values.coordinatorIds && Array.isArray(values.coordinatorIds) && values.coordinatorIds.length > 0) {
            values.coordinatorId = values.coordinatorIds[0];
        }

        const blobName = `${values.name.replace(/\s/g, '')}`;  // used as file basename
        const res = await uploadFile(blobName);
        if (!res || !res.url) {
            openNotification('error', 'Upload failed', 'Failed to upload course cover image. Please try again.');
            setIsLoading(false);
            return;
        }
        values.coverImage = res.url;

        try {
            const res = await addCourse(values);
            if (res && res.status === 200) {
                openNotification('success',
                    'Course added successfully',
                    'New course has been added successfully'
                );
                setOpen(false);
                setFileList([]);
                form.resetFields();
                setInstallmentCount(0);
                // Force refresh of courses
                await hadleGetCources();
            } else {
                openNotification('error',
                    'Error adding course',
                    res?.data?.message || 'Failed to add course. Please try again.'
                );
            }
        } catch (error) {
            console.error('AddCource', error);
            openNotification('error',
                'Error adding course',
                'An error occurred while adding the course. Please try again.'
            );
        }

        setIsLoading(false);
    }

    const openNotification = (type, message, description) => {
        api[type]({
            message: message,
            description: description,
        });
    }

    const uploadFile = async (baseName) => {
        try {
            const formData = new FormData();
            formData.append('image', fileList[0].originFileObj);
            formData.append('fileName', baseName);

            const response = await fetch(UPLOAD_COURSE_THUMBNAIL_URL, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (!data.success) {
                throw new Error(data.message || 'Upload failed');
            }
            return data;
        } catch (error) {
            console.error('uploadFile error:', error);
            return null;
        }
    }

    const onChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    return (
        <div>
            {contextHolder}
            <Drawer
                title="Add new course"
                width={720}
                onClose={() => setOpen(false)}
                open={isOpen}
                styles={{
                    body: {
                        paddingBottom: 80,
                    },
                }}
            >
                <Spin
                    spinning={isLoading}
                    tip="Adding new course..."
                >
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        form={form}
                    >
                        <Form.Item
                            name="courseid"
                            label="Course ID"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter course's ID",
                                },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={200}
                                placeholder="Please enter course ID" />
                        </Form.Item>
                        <Form.Item
                            name="name"
                            label="Course Name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter course's name",
                                },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={200}
                                placeholder="Please enter course's name" />
                        </Form.Item>
                        <Form.Item
                            name="instructorIds"
                            label="Assign Instructors"
                        >
                            <Select
                                mode="multiple"
                                placeholder="Select instructors to assign to this course"
                                allowClear
                                showSearch
                                optionFilterProp="children"
                            >
                                {instructors.map(inst => (
                                    <Option key={inst.id} value={inst.id}>
                                        {inst.name} ({inst.email})
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="description"
                            label="Course Description"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter course's discription",
                                },
                            ]}
                        >
                            <ReactQuill
                                theme="snow"
                                modules={quillModules}
                                placeholder="Please enter course's description"
                            />
                        </Form.Item>
                        <Form.Item
                            name="tags"
                            label="Select course tags"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select course's tags",
                                },
                            ]}
                        >
                            <Select
                                mode="multiple"
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Please select"
                                options={[
                                    // Base Tags
                                    { label: 'Video Tutorials', value: 'VideoTutorials' },
                                    { label: 'Exams', value: 'Exams' },
                                    { label: 'Training and Courses', value: 'TrainingAndCourses' },
                                    { label: 'News', value: 'News' },
                                    { label: 'Seminar', value: 'Seminar' },

                                    // Management
                                    { label: 'Category: Management', value: 'Management' },
                                    { label: '→ Business Management', value: 'Business Management' },
                                    { label: '→ Human Resource Management', value: 'Human Resource Management' },
                                    { label: '→ Entrepreneurship', value: 'Entrepreneurship' },
                                    { label: '→ Project Management', value: 'Project Management' },
                                    { label: '→ Office Administration', value: 'Office Administration' },

                                    // Accounting & Finance
                                    { label: 'Category: Accounting & Finance', value: 'Accounting & Finance' },
                                    { label: '→ Diploma in Accounting', value: 'Diploma in Accounting' },
                                    { label: '→ QuickBooks Accounting', value: 'QuickBooks Accounting' },
                                    { label: '→ Computerized Accounting', value: 'Computerized Accounting' },
                                    { label: '→ Taxation', value: 'Taxation' },
                                    { label: '→ Auditing', value: 'Auditing' },
                                    { label: '→ Financial Management', value: 'Financial Management' },

                                    // Data Analytics & IT
                                    { label: 'Category: Data Analytics & IT', value: 'Data Analytics & IT' },
                                    { label: '→ Advanced Excel', value: 'Advanced Excel' },
                                    { label: '→ Power BI', value: 'Power BI' },
                                    { label: '→ Data Analytics', value: 'Data Analytics' },
                                    { label: '→ Dashboard Reporting', value: 'Dashboard Reporting' },
                                    { label: '→ Business Intelligence', value: 'Business Intelligence' },

                                    // Artificial Intelligence (AI)
                                    { label: 'Category: Artificial Intelligence (AI)', value: 'Artificial Intelligence (AI)' },
                                    { label: '→ AI for Business', value: 'AI for Business' },
                                    { label: '→ ChatGPT & AI Tools', value: 'ChatGPT & AI Tools' },
                                    { label: '→ Prompt Engineering', value: 'Prompt Engineering' },
                                    { label: '→ AI Productivity', value: 'AI Productivity' },
                                    { label: '→ AI for Marketing', value: 'AI for Marketing' },

                                    // Logistics & Supply Chain
                                    { label: 'Category: Logistics & Supply Chain', value: 'Logistics & Supply Chain' },
                                    { label: '→ Logistics Management', value: 'Logistics Management' },
                                    { label: '→ Warehouse Management', value: 'Warehouse Management' },
                                    { label: '→ Shipping Management', value: 'Shipping Management' },
                                    { label: '→ Procurement Management', value: 'Procurement Management' },

                                    // Graphic Design & Multimedia
                                    { label: 'Category: Graphic Design & Multimedia', value: 'Graphic Design & Multimedia' },
                                    { label: '→ Graphic Design', value: 'Graphic Design' },
                                    { label: '→ Photoshop', value: 'Photoshop' },
                                    { label: '→ Illustrator', value: 'Illustrator' },
                                    { label: '→ Canva Design', value: 'Canva Design' },
                                    { label: '→ Video Editing', value: 'Video Editing' },

                                    // Architecture & Design
                                    { label: 'Category: Architecture & Design', value: 'Architecture & Design' },
                                    { label: '→ AutoCAD', value: 'AutoCAD' },
                                    { label: '→ Architectural Design', value: 'Architectural Design' },
                                    { label: '→ Interior Design', value: 'Interior Design' },
                                    { label: '→ 3D Visualization', value: '3D Visualization' },

                                    // Professional Exam Classes
                                    { label: 'Category: Professional Exam Classes', value: 'Professional Exam Classes' },
                                    { label: '→ Association of Accounting Technicians of Sri Lanka (AAT)', value: 'Association of Accounting Technicians of Sri Lanka (AAT)' },
                                    { label: '→ Chartered Accounting', value: 'Chartered Accounting' },
                                    { label: '→ Sri Lanka Institute of Marketing (SLIM)', value: 'Sri Lanka Institute of Marketing (SLIM)' },
                                    { label: '→ Professional Business Qualifications', value: 'Professional Business Qualifications' }
                                ]}
                            />
                        </Form.Item>
                        <Form.Item
                            name="orderNumber"
                            label="Order Number (The order of the course when displaying)"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter course's order number",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                placeholder="Please enter course's order number" />
                        </Form.Item>
                        <Form.Item
                            name="coverImage"
                            label="Course cover image"
                            rules={[
                                {
                                    required: true,
                                    message: "Please upload course's cover image",
                                },
                            ]}
                        >
                            <Upload
                                action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                                listType="picture-card"
                                fileList={fileList}
                                onChange={onChange}
                                onPreview={onPreview}
                                beforeUpload={file => {
                                    const isPNG = (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg');
                                    if (!isPNG) {
                                        message.error(`${file.name} is not a png file`);

                                        return isPNG || Upload.LIST_IGNORE;
                                    } else {
                                        return false;
                                    }
                                }}
                            >
                                {fileList.length < 1 && '+ Upload'}
                            </Upload>
                        </Form.Item>

                        <Form.Item
                            name='startDate'
                            label="Course Start Date"
                        >
                            <Input
                                type="date"
                                placeholder="Please enter course's start date" />
                        </Form.Item>

                        <Form.Item
                            name='duration'
                            label="Course Duration"
                        >
                            <Input
                                placeholder="Please enter course's duration (e.g. 6 Months, 3 Weeks)" />
                        </Form.Item>

                        <Form.Item
                            name='startTime'
                            label="Course Start Time"
                        >
                            <Input
                                type="time"
                                placeholder='Please enter course start time'
                            />
                        </Form.Item>

                        <Form.Item
                            name='isShowOnHome'
                            label="Show on Home Page"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select course's show on home page status",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Please select course's show on home page status"
                            >
                                <Option value="true">Yes</Option>
                                <Option value="false">No</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name='description1'
                            label="Description 1"
                        >
                            <ReactQuill
                                theme="snow"
                                modules={quillModules}
                                placeholder="Please enter course's description"
                            />
                        </Form.Item>

                        <Form.Item
                            name='whatsappGroupLink'
                            label="Whatsapp Group Link"
                        >
                            <Input
                                placeholder='Please enter whatsapp group link'
                            />
                        </Form.Item>

                        <Form.Item
                            name='videoUrl'
                            label="Video URL"
                        >
                            <Input
                                placeholder='Please enter video url'
                            />
                        </Form.Item>

                        <Form.Item
                            name='coordinatorIds'
                            label="Assign Coordinators"
                        >
                            <Select
                                mode="multiple"
                                placeholder="Select coordinator users"
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                onChange={(selectedIds) => {
                                    if (selectedIds && selectedIds.length > 0) {
                                        const names = selectedIds.map(id => coordinators.find(c => c.id === id)?.name).filter(Boolean);
                                        const whatsapps = selectedIds.map(id => coordinators.find(c => c.id === id)?.contactNumber).filter(Boolean);
                                        form.setFieldsValue({
                                            coordinatorName: names.join(', '),
                                            coordinatorWhatsApp: whatsapps.join(', ')
                                        });
                                    } else {
                                        form.setFieldsValue({
                                            coordinatorName: undefined,
                                            coordinatorWhatsApp: undefined
                                        });
                                    }
                                }}
                            >
                                {coordinators.map(coord => (
                                    <Option key={coord.id} value={coord.id}>
                                        {coord.name} ({coord.email})
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name='coordinatorName'
                            label="Coordinator Name"
                        >
                            <Input
                                placeholder='Please enter coordinator name'
                            />
                        </Form.Item>

                        <Form.Item
                            name='coordinatorWhatsApp'
                            label="Coordinator WhatsApp Number"
                        >
                            <Input
                                placeholder='Please enter coordinator whatsapp number'
                            />
                        </Form.Item>

                        <Form.Item
                            name="isPublished"
                            label="Course is Published"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select course's published status",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Please select course's published status"
                            >
                                <Option value="true">Published</Option>
                                <Option value="false">Not Published</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="price"
                            label="Standard Course Price (LKR)"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter course's standard price",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                placeholder="Please enter course's standard price" />
                        </Form.Item>

                        <Form.Item name="isPromoActive" label="Promotional Pricing Active" initialValue={false}>
                            <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item name="promoPrice" label="Promotional Price (LKR)">
                            <Input type="number" placeholder="Enter promo price" />
                        </Form.Item>

                        <Form.Item name="promoStartDate" label="Promo Start Date">
                            <Input type="date" />
                        </Form.Item>

                        <Form.Item name="promoEndDate" label="Promo End Date">
                            <Input type="date" />
                        </Form.Item>

                        <Divider orientation="left">Alumni Pricing (Optional)</Divider>

                        <Form.Item name="prerequisiteCourseIds" label="Prerequisite/Alumni Courses">
                            <Select mode="multiple" placeholder="Select courses that grant alumni discount">
                                {allCources?.map(c => (
                                    <Option key={c.id} value={c.id}>{c.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item name="alumniDiscount" label="Alumni Discount Amount (LKR)">
                            <Input type="number" placeholder="Enter discount amount for alumni" />
                        </Form.Item>

                        <Form.Item
                            name='installments'
                            label="Number of Installments"
                        >
                            <Input
                                type="number"
                                min={0}
                                placeholder='Please enter number of installments'
                                onChange={handleInstallmentCountChange}
                            />
                        </Form.Item>

                        {installmentCount > 0 && (
                            <div style={{ overflowX: 'auto', marginBottom: 16 }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #f0f0f0' }}>
                                    <thead>
                                        <tr style={{ background: '#fafafa' }}>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>#</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>Standard Amount (LKR)</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>Alumni Amount (LKR)</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>Due Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.from({ length: installmentCount }).map((_, index) => (
                                            <tr key={`installment-row-${index}`} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                <td style={{ padding: '8px 12px', verticalAlign: 'top', fontWeight: 500, width: 40 }}>{index + 1}</td>
                                                <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                                                    <Form.Item
                                                        name={['installmentAmounts', index]}
                                                        style={{ marginBottom: 0 }}
                                                        rules={[{ required: true, message: `Required` }]}
                                                    >
                                                        <Input type="number" min={0} step="0.01" placeholder="Standard amount" />
                                                    </Form.Item>
                                                </td>
                                                <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                                                    <Form.Item
                                                        name={['alumniInstallmentAmounts', index]}
                                                        style={{ marginBottom: 0 }}
                                                    >
                                                        <Input type="number" min={0} step="0.01" placeholder="Alumni amount" />
                                                    </Form.Item>
                                                </td>
                                                <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                                                    <Form.Item
                                                        name={['installmentDueDate', index]}
                                                        style={{ marginBottom: 0 }}
                                                    >
                                                        <Input type="date" />
                                                    </Form.Item>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <Form.Item
                            name="isAppearOnHome"
                            label="Appear on Home Page"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select course's appear on home page status",
                                },
                            ]}
                        >
                            <Radio.Group>
                                <Radio value={true}>
                                    Yes
                                </Radio>
                                <Radio value={false}>
                                    No
                                </Radio>
                            </Radio.Group>
                        </Form.Item>


                        <Row gutter={16}>
                            <Col span={12}>
                                <Button type="primary" htmlType="submit">
                                    Add Course
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Drawer>
        </div>
    )
}

export default AddCource